module.exports = __webpack_public_path__ + "img/footer-2_jp.9b97523.jpg";